<div class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>ID</th>
        <th translate>NAME</th>
        <th *ngIf="!isJosam" translate>Q_POPNR</th>
        <th *ngIf="isJosam" translate>JOSAM_STATNR</th>
        <th translate *ngIf="includeAvailability">AVAILABILITY</th>
        <th translate>PRICE</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td [attr.data-label]="'ID' | translate" *ngIf="item.replacementId == null">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.id }}
          </a>
        </td>
        <td [attr.data-label]="'ID' | translate" *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a (click)="goToDetail(item)" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a (click)="goToDetail(item)" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td [attr.data-label]="'NAME' | translate">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.name }}
          </a>
        </td>
        <td *ngIf="!isJosam" [attr.data-label]="'Q_POPNR' | translate">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.product?.extra?.ar.q_popnr }}
          </a>
        </td>
        <td *ngIf="isJosam" [attr.data-label]="'JOSAM_STATNR' | translate">
          <a (click)="goToDetail(item)" class="text-dark">
            {{ item.product?.extra?.ar?.artnrean }}
          </a>
        </td>
        <td [attr.data-label]="'AVAILABILITY' | translate" *ngIf="includeAvailability">
          <lib-availability [availability]="item.availability" [isSales]="isSales"></lib-availability>
        </td>
        <td [attr.data-label]="'PRICE' | translate" style="width: 250px;" class="text-c">
          @if (item.product.extra._parentProduct?.extra.ar?.itemstatuscode === 98) {
          @if (item.price?.extra?.contactSalesRep) {
          <span class="font-weight-bold" translate>CONTACT_YOUR_SALES_REPRESENTATIVE</span>
          }
          <span *ngIf="item.price && !item.price.extra?.contactSalesRep">
            <span class="font-weight-bold">
              {{ item.price.customerNetPrice.value | gungCurrency: item.price.customerNetPrice.currencyCode:'code' }}
            </span>
            <span *ngIf="item.price.customerDiscountPercent !== 0"
              >({{ item.price.customerGrossPrice.value | number: '1.0-0' }}&nbsp;-{{
                item.price.customerDiscountPercent
              }}%)</span
            >
          </span>
          <lib-buy-btn [id]="item.product.id" [product]="item.product"></lib-buy-btn>
          }
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="findError" class="mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>
